
import { defineComponent } from "vue";

export default defineComponent({
  name: "CourseTracksSection",
  props: {
    flagName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
});
